import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'welcome',
    loadComponent: () => import('./features/welcome/welcome.component').then(m => m.WelcomeComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/auth/forgot-reset-pass/forgot-reset-pass.component').then(m => m.ForgotResetPassComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./features/auth/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'tabs',
    loadComponent: () => import('./features/tabs/tabs.component').then(m => m.TabsComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/tabs/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      // You can generate and add these components later
      // {
      //   path: 'search',
      //   loadComponent: () => import('./features/tabs/search/search.component').then(m => m.SearchComponent)
      // },
      {
        path: 'profile',
        loadComponent: () => import('./features/tabs/profile/profile.component').then(m => m.ProfileComponent)
      },
      {
        path: 'search',
        loadComponent: () => import('./features/tabs/search/search.component').then(m => m.SearchComponent)
      },
      {
        path: 'matches',
        loadComponent: () => import('./features/tabs/matches/matches.component').then(m => m.MatchesComponent)
      },
      {
        path: '',
        redirectTo: '/tabs/dashboard',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'profile/edit',
    loadComponent: () => import('./features/tabs/profile/edit-profile/edit-profile.component').then(m => m.EditProfileComponent)
  },
  {
    path: 'profile/preferences',
    loadComponent: () => import('./features/tabs/profile/partner-preferences/partner-preferences.component').then(m => m.PartnerPreferencesComponent)
  },
  {
    path: 'profile/security',
    loadComponent: () => import('./features/tabs/profile/privacy-security/privacy-security.component').then(m => m.PrivacySecurityComponent)
  },
  {
    path: 'profile/support',
    loadComponent: () => import('./features/tabs/profile/help-support/help-support.component').then(m => m.HelpSupportComponent)
  },
  {
    path: 'profile/contact-us',
    loadComponent: () => import('./features/tabs/profile/contact-us/contact-us.component').then(m => m.ContactUsComponent)
  },
  {
    path: 'view-profile',
    loadComponent: () => import('./features/view-profile/view-profile.component').then(m => m.ViewProfileComponent)
  },
  {
    path: 'chat',
    loadComponent: () => import('./features/chat-detail/chat-detail.component').then(m => m.ChatDetailComponent)
  },
  {
    path: 'services',
    loadComponent: () => import('./features/services/services.component').then(m => m.ServicesComponent)
  },
    {
    path: 'premium',
    loadComponent: () => import('./features/premium/premium.component').then(m => m.PremiumComponent)
  },
  {
    path: 'notifications',
    loadComponent: () => import('./features/notifications/notifications.component').then(m => m.NotificationsComponent)
  },
  {
    path: 'profile-list',
    loadComponent: () => import('./features/profile-list/profile-list.component').then(m => m.ProfileListComponent)
  }

];